import store from '../../store';

const login = import('@/components/login'),
	verifyDevice = import('@/components/login/verify-device'),
	success = import('@/components/login/success'),
	zendesk = import('@/components/login/zendesk'),
	sso = import('@/components/login/sso'),
	logout = import('@/components/logout'),
	sMode = import('@/components/login/s-mode'),
	nMode = import('@/components/login/n-mode'),
	migration = import('@/components/login/migration'),
	migrationTPA = import(/* webpackChunkName: "ui-tpa" */ '@/components/login/migration-tpa'),
	loginTPA = import(/* webpackChunkName: "ui-tpa" */ '@/components/login-tpa'),
	socialLink = import(/* webpackChunkName: "ui-tpa" */ '@/components/social-link'),
	migrationComplete = import('@/components/login/migration-complete'),
	settingSocialLink = import('@/components/setting/social-link'),
	legacyTPA = import('@/components/legacy-tpa'),
	loginRoutes = [
		{
			path: '/:locale/login',
			name: 'login',
			components: {
				body: () => login,
			},
			props: { body: true },
			beforeEnter(to, from, next) {
				if (store.state.channel === 'steam') {
					// steam connector shouldn't show login page
					window.launcherLoginCancel();
				} else {
					next();
				}
			},
		},
		{
			path: '/:locale/logout',
			name: 'logout',
			components: {
				body: () => logout,
			},
		},
		{
			path: '/:locale/login/verify-device',
			name: 'verify-device',
			components: {
				body: () => verifyDevice,
			},
		},
		{
			path: '/:locale/login/tpa/:socialProvider?',
			name: 'login-tpa',
			components: {
				body: () => loginTPA,
			},
			props: { body: true },
		},
		{
			path: '/:locale/login/legacy-tpa/:socialProvider?',
			name: 'legacy-tpa',
			components: {
				body: () => legacyTPA,
			},
			props: { body: true },
		},
		{
			path: '/:locale/login/social-link/:case',
			name: 'login-social-link',
			components: {
				body: () => socialLink,
			},
			props: { body: true },
		},
		{
			path: '/:locale/login/callback/:socialProvider',
			name: 'login-tpa-callback',
			beforeEnter: (to, from, next) => {
				let state;
				// to support a redirect mode of google oauth
				if (to.hash) {
					const params = new URLSearchParams(to.hash.slice(1));
					to.query.code = params.get('id_token') || params.get('access_token');
					state = params.get('state');
				}
				if (state === 'socialLink') {
					next({
						replace: true,
						name: 'setting-social-link',
						params: to.params,
						query: to.query,
					});
				} else if (state === 'legacyTPA') {
					next({
						replace: true,
						name: 'legacy-tpa',
						params: to.params,
						query: to.query,
					});
				} else {
					next({
						replace: true,
						name: 'login-tpa',
						params: to.params,
						query: to.query,
					});
				}
			},
		},
		{
			path: '/:locale/settings/social-link/:socialProvider',
			name: 'setting-social-link',
			components: {
				body: () => settingSocialLink,
			},
			props: { body: true },
		},
		{
			path: '/:locale/login/s-mode',
			name: 'smode',
			components: {
				body: () => sMode,
			},
		},
		{
			path: '/:locale/login/n-mode',
			name: 'nmode',
			components: {
				body: () => nMode,
			},
		},
		{
			path: '/:locale/login/success',
			name: 'success',
			components: {
				body: () => success,
			},
		},
		{
			path: '/:locale/login/zendesk',
			name: 'zendesk',
			components: {
				body: () => zendesk,
			},
		},
		{
			path: '/:locale/login/sso',
			name: 'sso',
			components: {
				body: () => sso,
			},
		},
		{
			path: '/:locale/login/migration',
			name: 'migration',
			components: {
				body: () => migration,
			},
		},
		{
			path: '/:locale/login/migration-tpa',
			name: 'migration-tpa',
			components: {
				body: () => migrationTPA,
			},
		},
		{
			path: '/:locale/login/migration-complete',
			name: 'migration-complete',
			components: {
				body: () => migrationComplete,
			},
		},
	];

export default loginRoutes;



// WEBPACK FOOTER //
// ./src/router/routes/login.js